<div class="dialog-container">
    <div class="dialog__body">
        <p class="dialog__message">{{msg}}</p>
    </div>

    <div class="dialog__actions">
        <button type="button" mat-dialog-close class="fo-btn fo-btn--quiet" (click)="close(false)">No</button>
        <button type="button" mat-dialog-close class="fo-btn fo-btn--primary" (click)="close(true)">Sì</button>
    </div>
</div>
